<!--  -->
<template>
  <div class="tabox">
    <el-table
      :data="tabledata"
      max-height="750"
      border
    >
      <el-table-column
        prop="strategy_preview_no"
        width="230"
        label="策略编号"
        align="center"
      />
      <el-table-column
        prop="account_name"
        width="180"
        label="公众号名称"
        align="center"
      />
      <el-table-column
        prop="app_id"
        width="180"
        label="公众号appId"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        width="180"
        label="发送时间"
        align="center"
      />
      <el-table-column
        prop="sent_count"
        width="80"
        label="发送人数"
        align="center"
      />
      <el-table-column
        prop="sent_success_count"
        width="80"
        label="成功条数"
        align="center"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { strategyPreviewSendHistory } from '@/api/sourceMaterial'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      tabledata: [],
      query: {
        strategy_preview_no: null,
        page: 0,
        pageSize: 10
      },
      total: null
    }
  },
  created() {
    this.query.strategy_preview_no = this.$route.query.item
    this.list()
  },
  mounted() {

  },
  methods: {
    async list() {
      const data = await strategyPreviewSendHistory(this.query)
      this.tabledata = data.data.list
      this.total = data.data.total
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    }
  }
}
</script>
<style scoped>
.tabox{
  padding: 30px;
}
.tabselecr_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.titip{
    width: 180px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    overflow: hidden;
}
</style>
